<div class="file-input-container">
    <input type="file" id="fileInput" (change)="onFileSelected($event)" style="display: none;" #fileInput>
    <button mat-raised-button color="primary" type="button" (click)="fileInput.click()"><mat-icon>attach_file</mat-icon> Upload File</button>    
    <span *ngIf="selectedFile; else noFile" class="file-label">{{ selectedFile.name }}</span>
    <button mat-icon-button color="primary" type="button" (click)="onFileLoad()" [disabled]="!selectedFile"><mat-icon>send</mat-icon></button>  
    <ng-template #noFile>
        <span class="file-label">No file uploaded</span>
    </ng-template>
</div>